import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import useParent from '../hooks/useParent.js';

export default function ProtectedParentRoute({ children }) {
  const { parent, isParentLoading } = useParent();
  const location = useLocation();

  if (isParentLoading) {
    return <div>Loading...</div>; // Todo: implement a full-screen spinner
  }

  if (!parent) {
    return <Navigate to="/parent/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
